export var global = {
   url: 'https://votaciones.corhuila.edu.co/api/'
}


